import { useParamOrNull } from 'dg-web-shared/lib/ReactRouterHelpers.ts';
import { useEffect } from 'react';

export function QRRedirect() {
    const identificationQr = useParamOrNull('identificationQr');
    const url = `https://parkingqr.ch/qr/${identificationQr}`;

    useEffect(() => {
        window.location.assign(url);
    }, [url]);
    return <a href={url}>Moved here</a>;
}
